import Close from '@/app/_components/ui/icons/Close.svg';
import Like from '@/app/_components/ui/icons/Like.svg';
import Dislike from '@/app/_components/ui/icons/Dislike.svg';
import QuestionWrap from '@/app/_components/ui/icons/QuestionWrap.svg';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Modal from 'react-modal';
import * as Yup from 'yup';
import TickSlider from '@/app/_components/share/TickSlider';
import StarRating from '@/app/_components/share/StarRating';
import { useSession } from 'next-auth/react';
import { useUpdateComment } from '@/app/_hooks/useComment';
import { toast } from 'react-toastify';
import Input from '@/app/_components/share/formInputs/Input';
import ArrayInput from '@/app/_components/share/formInputs/ArrayInput';
import { indiciesTitle } from '@/app/_libs/utils/constants/indicies';
import TextArea from '@/app/_components/share/formInputs/TextArea';
import FilesInput from '@/app/_components/share/formInputs/FilesInput';
import { purchaseOfferStates } from '@/app/_libs/utils/constants/purchaseOffer';
import CheckBoxInput from '@/app/_components/share/formInputs/CheckBoxInput';
import LoadingIcon from '../../share/LoadingIcon';

const iconComponents = {
  Like,
  Dislike,
  QuestionWrap,
};

export default function CommentForm({ openModal, onClose, productId }) {
  const [advantages, setAdvantages] = useState([]);
  const [disAdvantages, setDisadvantages] = useState([]);
  const [advInput, setAdvInput] = useState('');
  const [disAdvInput, setDisAdvInput] = useState('');
  const [indicies, setIndicies] = useState([...indiciesTitle]);
  const [purchaseOffer, setPurchaseOffer] = useState(1);
  const [images, setImages] = useState([]);
  const [starRating, setStarRating] = useState(null);
  const [previewFiles, SetPreviewFiles] = useState([]);
  const [isSendingForm, setIsSendingForm] = useState(false);
  const { data: session } = useSession();
  const updateProductComment = useUpdateComment();
  const [ratingWarning, setRatingWarning] = useState(null);
  const [uploadFilesWarning, setUploadImageWarning] = useState(null);

  const formSchema = Yup.object().shape({
    cmSubject: Yup.string().required('فیلد عنوان دیدگاه ضروری است'),
    cmContent: Yup.string().required('فیلد توضیح دیدگاه ضروری است'),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(formSchema),
  });

  const uploadSingleFile = (e) => {
    if (e.target.files[0].size > 1048576) {
      setUploadImageWarning(
        'حجم فایل بیش از 1 مگابایت است. لطفا فایل دیگری انتخاب کنید.'
      );
      return;
    }
    let file = URL.createObjectURL(e.target.files[0]);
    setUploadImageWarning(null);
    setImages([...images, e.target.files[0]]);
    SetPreviewFiles([...previewFiles, file]);
  };
  const deleteFile = (e) => {
    const s = images.filter((item, index) => index !== e);
    setImages(s);
  };

  //  submit comment form handler **********************
  const submitCommentFormHandler = async (values) => {
    if (!starRating) {
      setRatingWarning('لطفا به محصول امتیاز دهید');
      return;
    }
    const token = session?.user.accessToken;
    setIsSendingForm(true);
    updateProductComment.mutate(
      {
        token,
        values,
        images,
        advantages,
        disAdvantages,
        indicies,
        productId,
        starRating,
        purchaseOffer,
      },
      {
        onSuccess: () => {
          setIsSendingForm(false);
          toast.dark('دیدگاه شما با موفقیت ثبت شد');
          reset();
          setAdvantages([]);
          setDisadvantages([]);
          SetPreviewFiles([]);
          setImages([]);
          onClose();
        },
      }
    );
  };
  // handler change tick slider component **************
  const tikSliderHandler = (value, title) => {
    let newIndicies = indicies;
    newIndicies.map((indice) => {
      if (indice.name === title) {
        indice.value = value;
      }
    });
    setIndicies([...newIndicies]);
  };

  const advInputHandler = (event) => {
    setAdvInput(event.target.value);
  };

  const disadvInputHandler = (event) => {
    setDisAdvInput(event.target.value);
  };
  // handler add new disAdvantage **************
  const addDisadvantage = () => {
    setDisadvantages([...disAdvantages, disAdvInput]);
  };
  const addAdvantage = () => {
    setAdvantages([...advantages, advInput]);
  };
  const removeAdvantage = (advValue) => {
    setAdvantages(advantages.filter((item) => item !== advValue));
  };
  const removeDisadvantage = (disadvValue) => {
    setDisadvantages(disAdvantages.filter((item) => item !== disadvValue));
  };

  return (
    <div>
      <Modal
        isOpen={openModal}
        onRequestClose={onClose}
        ariaHideApp={false}
        portalClassName="modalAddComment"
        className="commentModal"
        overlayClassName="modalOverlay"
        style={{
          content: {
            maxWidth: '872px',
            background: '#fff',
            border: '1px solid gray',
            height: '660px',
            overflowY: 'hidden',
          },
        }}
      >
        <div className="flex justify-between p-5 pb-1">
          <h2>ثبت دیدگاه</h2>
          <button onClick={onClose}>
            <Close />
          </button>
        </div>
        <div className="pt-2 pb-4">
          <div className="w-full border-t border-light-gray-200"></div>
        </div>
        <form
          className="w-full h-full max-w-lg pb-40 md:pb-10"
          id="addComment"
          onSubmit={handleSubmit(submitCommentFormHandler)}
        >
          <div className="flex overflow-y-auto h-full  p-6">
            <div className="w-full -mx-3 lg:flex h-[840px] ">
              <div className="flex  px-3  flex-col w-full lg:w-5/12">
                <div className=" w-full justify-between mb-6">
                  <Input
                    register={register}
                    errors={errors}
                    name="cmSubject"
                    label="عنوان نظر"
                    required
                  />
                </div>
                <div className="w-full mb-6">
                  <ArrayInput
                    register={register}
                    errors={errors}
                    name="advantages"
                    label="نقاط قوت"
                    onChange={advInputHandler}
                    addItem={addAdvantage}
                    removeItem={removeAdvantage}
                    items={advantages}
                  />
                </div>
                <div className="w-full mb-6">
                  <ArrayInput
                    register={register}
                    errors={errors}
                    name="disadvantages"
                    label=" نقاط ضعف"
                    onChange={disadvInputHandler}
                    addItem={addDisadvantage}
                    removeItem={removeDisadvantage}
                    items={disAdvantages}
                    cons={true}
                  />
                </div>
                <div className="w-full mb-6 ">
                  <TextArea
                    register={register}
                    errors={errors}
                    name="cmContent"
                    label="دیدگاه شما"
                    required
                  />
                </div>
                <div className="w-full mb-4">
                  <FilesInput
                    register={register}
                    errors={errors}
                    name=""
                    label={'عکس محصول را بارگذاری کنید'}
                    description={' فرمت JPG یا PNG و هر عکس حداکثر 1 مگابایت'}
                    onchange={uploadSingleFile}
                    files={previewFiles}
                    deleteFile={deleteFile}
                  />
                  {uploadFilesWarning && (
                    <div className=" inputValidation text-xs text-red-800">
                      {uploadFilesWarning}
                    </div>
                  )}
                </div>
              </div>
              {/* first column *************** */}
              <div className="flex lg:w-7/12 w-full lg:border-r px-6 border-light-gray-200">
                <div className="w-full ">
                  <div className=" w-full charts ">
                    <div className="slider-tick-wrap">
                      {indicies.map((indice, index) => (
                        <div key={index}>
                          <TickSlider
                            value={indice.value}
                            title={indice.name}
                            onChangeValue={tikSliderHandler}
                          />
                        </div>
                      ))}
                    </div>
                    <div className="rateProduct flex text-sm items-center mt-10">
                      <div>
                        امتیاز دهید<span className="text-red-500">*</span>
                      </div>
                      <div className="pr-4">
                        <StarRating
                          onChange={(value) => {
                            setStarRating(value);
                            setRatingWarning(null);
                          }}
                          starValue={starRating}
                        />
                      </div>
                    </div>
                    {ratingWarning && (
                      <div className=" inputValidation text-xs text-red-800">
                        {ratingWarning}
                      </div>
                    )}
                    <div className="suggestToBuyers mt-10">
                      <div className="text-sm">پیشنهاد شما به خریداران</div>
                      <div>
                        {purchaseOfferStates.map((offerState, index) => {
                          const IconComponent = iconComponents[offerState.icon];
                          return (
                            <div
                              key={index}
                              className={`border ${
                                purchaseOffer == offerState.value
                                  ? 'border-color-primary'
                                  : 'border-light-gray-300'
                              }  rounded-md flex p-4 mt-4 text-sm`}
                              onClick={() => setPurchaseOffer(offerState.value)}
                            >
                              <IconComponent
                                {...(offerState.type && {
                                  ...(offerState.type == 'stroke'
                                    ? { stroke: '#292D32' }
                                    : { fill: '#292D32' }),
                                })}
                              />
                              <span className="pr-2">{offerState.label}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <CheckBoxInput
                      register={register}
                      errors={errors}
                      name="anonymous"
                      label="ارسال دید‌گاه به صورت ناشناس"
                    />
                  </div>
                </div>
              </div>
              {/* second column *************** */}
            </div>
          </div>
        </form>
        <div className="flex items-center justify-between z-50 modal-button p-5 border-t border-light-gray-300 absolute bottom-0 left-0 right-0 bg-white">
          <div className="md:text-xs  text-tiny text-black">
            ثبت دیدگاه به معنی موافقت باقوانین انتشار برقچی است.
          </div>
          <div className="flex">
            <button
              className="px-8 lg: py-2 border-gray-500 border text-gray-500 hidden lg:block text-sm rounded-md"
              type="button"
              onClick={onClose}
            >
              انصراف و بستن
            </button>
            <button
              className="md:px-8 px-4 py-2 bg-color-primary text-white whitespace-nowrap text-xs md:text-sm rounded-md mr-4"
              type="submit"
              form="addComment"
              disabled={isSendingForm}
            >
              {isSendingForm ? <LoadingIcon /> : ' ثبت دیدگاه'}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
